import { ContainerModule } from "inversify";
import {
  PainelDeIntegracaoesDi,
  PainelDeIntegracaoesGateway
} from "../services/PainelDeIntegracaoesGateway";
import PainelDeIntegracoesGatewayAdapter from "../services/PainelDeIntegracoesGatewayAdapter";

const painelIntegracoesContainer = new ContainerModule((bind) => {
  bind<PainelDeIntegracaoesGateway>(PainelDeIntegracaoesDi).to(
    PainelDeIntegracoesGatewayAdapter
  );
});

export { painelIntegracoesContainer };
